import type { VariantPage } from "@/lib/api/formatting/rorosTweed/productPage";

import UI from "./UI";

type VariantProps = {
  variants: NonNullable<
    NonNullable<VariantPage["info"]>["details"]
  >["variants"];
  variantName: string | undefined;
  sku: string | undefined;
};

const Variants = (props: VariantProps) => {
  const variants = props.variants;
  if (!variants) {
    return <></>;
  }
  return (
    <>
      <UI {...props} />
    </>
  );
};

export default Variants;
